<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import performance_surrAPI from "@/services/standards/performance_surr/performance_surrAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "Rendición sobre el desempeño",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {

    return {
      title: "",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Rendición sobre el desempeño",
          active: true,
        },
      ],

      usersList: null,
      lista: [],
      file: null,
      loading: true,

      item: null,
      itemStatus: null,
      deleteCount: 0,

      itemData: null,

      performance_surr: {
        file: null,
        roles: this.actualRole,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      submitted: false,
      actualRole: null,
      nit: this.$store.getters["company/getCompany"].nit || null
    };
  },
  methods: {

    gotoDigitalOcean(url) {
      window.open(url);
    },

    getItemData() {
      ItemAPI.getItems(52)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getFile(file) {
      const name = file.split('/')
      return name[name.length - 1]
    },

    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 52)
        .then(response => {
          this.item = response || null
          this.itemStatus = response.status ? response.status : null
        })
        .catch(error => {
          console.log(error)
        })
    },

    /**
         * This method is used to send notification to SST user and SST company.
         * The sendNotification method import is required.
         * @param {Number} messageID - The message ID that will be associated to notification.
         * @param {Number} itemID - The item ID that will be associated to notification.
         * @param {Boolean} user - The user that will e associated to notification.
         * @return {Boolean} True if the notification is sent, false if not.
         */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },


    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.performance_surr.file)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/2.6.1/${this.performance_surr.employee_id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/2.6.1/${this.performance_surr.employee_id}/${name}`;
        }

        const result = await uploadDocument(url, this.file);
        if (result) {
          this.performance_surr.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getPerformance() {
      performance_surrAPI.getPerformance(this.$route.params.id)
        .then((response) => {
          this.loading = false
          this.actualRole = response.roles
          this.performance_surr = {
            roles: response.roles,
            employee_id: response.employee_id,
            file: response.file,
            companies_id: response.companies_id
          };
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async update() {
      this.submitted = true
      this.loading = true
      let response = await this.uploadDocument();
      if (response) {
        performance_surrAPI.update(this.$route.params.id, {
          roles: this.performance_surr.roles,
          employee_id: this.performance_surr.employee_id,
          file: this.performance_surr.file,
          companies_id: this.performance_surr.companies_id,
        })
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 17,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Informacion actualizada con éxito!",
                    text: "¡Informacion actualizada con éxito!",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                }, 2000)
                this.$router.go(-1);
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "¡No se ha podido actualizar!",
            text: "¡No se ha podido actualizar!",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    async print() {
      try {
        const url = 'https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/1/Brigada-prevencion/ActadeconstitucionBrigadistas.docx'
        window.location.href = url
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id)
            .then((res) => {
              this.usersList = res.employee
            })
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  mounted() {
    this.getPerformance()
    this.getItems()
    this.getItemData();
    this.getUsers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                </div>

                <div class="col-6 text-right m-b-0">

                  <button :disabled="!allowAccess()" @click="print" class="btn btn-primary mx-1" id="tooltip">
                    <span class="btn-label"> <i class="bx bx-download"></i></span> Descargar
                  </button>

                  <b-tooltip target="tooltip" placement="left">
                    Descargar roles y responsabilidades SG-SST
                  </b-tooltip>
                </div>

              </div>

              <div class="row">
                <div class="col-6">
                </div>
              </div>
              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">
                  <b-form-group label-for="employee" class="col-md-6 px-2" label="Colaborador">
                    <select :disabled="!getRole('Crear') || !allowAccess()" required class="form-control"
                      v-model="performance_surr.employee_id">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group label-for="number" class="col-md-6 px-2" label="Roles en el SG-SST">
                    <select id="type" class="form-control" v-model="performance_surr.roles">
                      <b-form-select-option value="Nivel Gerencial"
                        :selected="performance_surr.roles === 'Nivel Gerencial'">
                        Nivel Gerencial
                      </b-form-select-option>
                      <b-form-select-option value="Mandos medios"
                        :selected="performance_surr.roles === 'Mandos medios'">
                        Mandos medios
                      </b-form-select-option>
                      <b-form-select-option value="Colaboradores"
                        :selected="performance_surr.roles === 'Colaboradores'">
                        Colaboradores
                      </b-form-select-option>
                      <b-form-select-option value="Responsable del SG SST"
                        :selected="performance_surr.roles === 'Responsable del SG-SST'">
                        Responsable del SG-SST
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Subir roles y responsabilidades" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" required type="file" id="file"
                      ref="file" name="file" browse-text="Buscar"
                      :placeholder="performance_surr.file ? getFile(performance_surr.file) : `Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

              </form>
            </div>
          </div>

        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>